import { Suspense, lazy } from "react";

import { Spin } from "antd";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./App.css";
import { notAuth, withAuth } from "./auth/authGuard";
import MainLayout from "./components/MainLayout";
import Routers from "./constants/routers";

// Not Auth
const LoginPage = notAuth(lazy(() => import("./pages/Login")));
const HealthCheckPage = notAuth(lazy(() => import("./pages/HealthCheck")));
const MaintenancePage = notAuth(lazy(() => import("./pages/MaintenancePage")));

// With Auth
const DashboardPage = withAuth(lazy(() => import("./pages/Dashboard")));
const VariableCostRegisterPage = withAuth(lazy(() => import("./pages/VariableCostRegister")));
const ApplicationCreatePage = withAuth(lazy(() => import("./pages/ApplicationCreate")));
const ApplicationReviewPage = withAuth(lazy(() => import("./pages/ApplicationReviewPage")));
const ContractsPage = withAuth(lazy(() => import("./pages/Contracts")));
const ContractsDetailPage = withAuth(lazy(() => import("./pages/Contracts/Detail")));
const NoticePage = withAuth(lazy(() => import("./pages/Notice")));
const SubrogationPaymentPage = withAuth(lazy(() => import("./pages/SubrogationPayment")));
const SubrogationPaymentCreatePage = withAuth(lazy(() => import("./pages/SubrogationPayment/Create")));
const SubrogationPaymentDetailPage = withAuth(lazy(() => import("./pages/SubrogationPayment/Detail")));
const InclusiveContractApplicationPage = withAuth(lazy(() => import("./pages/InclusiveContractApplication")));
const InclusiveContractDetailPage = withAuth(
  lazy(() => import("./pages/InclusiveContractApplication/InclusiveContractDetail"))
);
const InclusiveContractCreate = withAuth(
  lazy(() => import("./pages/InclusiveContractApplication/InclusiveContractCreate"))
);
const ReceivedInvoicePage = withAuth(lazy(() => import("./pages/ReceivedInvoice")));
const CancellationRegisterPage = withAuth(lazy(() => import("./pages/CancellationRegister")));
const BadRequestPage = withAuth(lazy(() => import("./pages/ErrorPage/BadRequest")));
const ForbiddenPage = withAuth(lazy(() => import("./pages/ErrorPage/Forbidden")));
const NotFoundPage = withAuth(lazy(() => import("./pages/ErrorPage/NotFound")));

function Router() {
  return (
    <>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Suspense fallback={<Spin fullscreen />}>
          <Routes>
            <Route path={Routers.Login} element={<LoginPage />} />
            <Route path={Routers.HealthCheck} element={<HealthCheckPage />} />
            <Route path={Routers.Maintenance} element={<MaintenancePage />} />

            <Route path={Routers.Dashboard} element={<DashboardPage />} />

            <Route element={<MainLayout />}>
              <Route path={Routers.VariableCostRegister} element={<VariableCostRegisterPage />} />
              <Route path={Routers.ApplicationCreate} element={<ApplicationCreatePage />} />
              <Route path={Routers.ApplicationCreate + "/:contractCode"} element={<ApplicationCreatePage />} />
              <Route path={Routers.ApplicationReview} element={<ApplicationReviewPage />} />
              <Route path={Routers.ContractsList} element={<ContractsPage />} />
              <Route path={Routers.ContractsDetail + "/:contractCode"} element={<ContractsDetailPage />} />
              <Route path={Routers.Notice} element={<NoticePage />} />
              <Route path={Routers.SubrogationPayment} element={<SubrogationPaymentPage />} />
              <Route path={Routers.SubrogationPayment + "/create"} element={<SubrogationPaymentCreatePage />} />
              <Route
                path={Routers.SubrogationPayment + "/:subrogationPaymentCode"}
                element={<SubrogationPaymentDetailPage />}
              />
              <Route path={Routers.InclusiveContractApplication} element={<InclusiveContractApplicationPage />} />
              <Route
                path={Routers.InclusiveContractDetail + "/:contractCode"}
                element={<InclusiveContractDetailPage />}
              />
              <Route path={Routers.InclusiveContractCreate} element={<InclusiveContractCreate />} />
              <Route path={Routers.InclusiveContractCreate + "/:contractCode"} element={<InclusiveContractCreate />} />
              <Route path={Routers.ReceivedInvoice} element={<ReceivedInvoicePage />} />
              <Route path={Routers.CancellationRegister} element={<CancellationRegisterPage />} />
              <Route path={Routers.BadRequest} element={<BadRequestPage />} />
              <Route path={Routers.Forbidden} element={<ForbiddenPage />} />
              <Route path={Routers.NotFound} element={<NotFoundPage />} />
            </Route>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
}

function App() {
  return (
    <>
      <Router />
    </>
  );
}

export default App;
